import { PrintingLabel, PrintingLabelDispenseItem } from '@absg/nim-client-shared';
import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { StationPrintingService } from 'core.services/station-printing.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { delay, takeUntil } from 'rxjs/operators';

@Component({
  selector: '[nc-print-notes-dev]',
  templateUrl: './print-dev-notes.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PrintNotesDevComponent implements AfterViewInit, OnDestroy {
  adminNotes = '';
  isModalOpen = new BehaviorSubject(false);

  @Input() set hotKeyTriggered(trigger: boolean) {
    this.isModalOpen.next(trigger);
  }
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onClose = new EventEmitter();
  @ViewChild('notesInput', { static: true }) notesField: ElementRef;
  componentIsDestroyed = new Subject<void>();

  constructor(
    private stationPrintingService: StationPrintingService,
  ) { }

  ngAfterViewInit(): void {
    this.isModalOpen.pipe(
      takeUntil(this.componentIsDestroyed),
      delay(50),
    ).subscribe((isOpen) => {
      if (isOpen) {
        this.notesField.nativeElement.focus();
        this.notesField.nativeElement.select();
         
        // this.adminNotes = 'First dose: begin infusion at 50mg/hr. and increase by 50mg/hr. until Max rate of 400mg/hr. is reached. For Subsequent infusions, may use "Rapid" infusion if: >no severe infusion-related evident during the first dose >no Clinically significant cardiovascular disease >Lymphocyte <5000/mm3 Rapid infusion= 90 minute infusion given as: 20% of total dose given in first 30 minutes followed by 80% of total dose over the next 60 minutes For patient NOT meeting "Rapid "infusion criteria Subsequent infusion rate is: 100mg/hr. starting, increased by 100mg/hr. every 30 minutes until max rate of 400mg/hr. is reached. FOR PATIENTS WITH HIGH TUMOR BURDEN: Consider for first cycle, split dose or delayed administration can be considered';
        // eslint-disable-next-line max-len
        this.adminNotes = 'FOR PATIENTS WITH HIGH TUMOR BURDEn: Consider FOR PATIENTS WITH HIGH TUMOR BURDEN: Consider FOR PATIENTS WITH HIGH TUMOR BURden: Consider FOR PATIENTS WITH HIGH TUMOR BURden: CONsider FOR PATIENTS WITH HIGH TUMOR BUrden: Consider FOR PATIENTS WITH HIGH TUMOR burden: Consider FOR PATients with high tumor burden: Consider FOR PATIents with high tumor burden: Consider FOR PATIEnts with high tumor burden: Consider FOR PATIENts with high tumor burden: Consider FOR PATIENTs with high tumor burden: Consider FOR PATIENTS with high tumor burden: Consider FOR PATIENTS With high tumor burden: Consider FOR PATIENTS WIth high tumor burden: Consider FOR PATIENTS WITh high tumor burden: Consider FOR PATIENTS WITH high tumor burden: Consider FOR PATIENTS WITH High tumor burden: Consider FOR PATIENTS WITH HIgh tumor burden: Consider FOR PATIENTS WITH HIGh tumor burden: Consider FOR PATIENTS WITH HIGH tumor burden: Consider FOR PATIENTS WITH HIGH Tumor burden: Consider FOR PATIENTS WITH HIGH TUmor burden: Consider FOR PATIENTS WITH HIGH TUMor burden: Consider FOR PATIENTS WITH HIGH TUMOr burden: Consider FOR PATIENTS WITH HIGH TUMOR burden: Consider FOR PATIENTS WITH HIGH TUMOR Burden: Consider FOR PATIENTS WITH HIGH TUMOR BUrden: Consider FOR PATIENTS WITH HIGH TUMOR BURden: Consider';
      }
    });
  }

  ngOnDestroy(): void {
    this.componentIsDestroyed.next();
    this.componentIsDestroyed.unsubscribe();
  }

  onConfirm(): void {
    if (this.adminNotes && this.adminNotes !== '') {
      const printingLabel: PrintingLabel = {
        clinicName: 'Test Clinic',
        clinicAddressLine1: '123 Drive Ln',
        clinicCity: 'The City',
        clinicState: 'XY',
        clinicZipCode: '12345',
        clinicPhoneNumber: '999-888-7777',
        attendingPhysicianFirstName: 'Doctor',
        attendingPhysicianLastName: 'Doctor',
        stationId: 'Station Foo',
        serviceDate: new Date(),
        patientFirstName: 'Lorem',
        patientLastName: 'Ipsum',
        patientId: '',
        dateOfBirth: new Date(1971, 11, 10),
        userId: 'JHJH833',
        userName: 'JSMith',
        userLastName: 'Jake',
        userFirstName: 'Smith',
        allergies: ['Corn', 'Wheat'],
        practiceName: 'Test Practice',
        pageNumber: 1,
        routeOnLabel: true,
        fluidOnLabel: true,
        durationOnLabel: true,
        infusionNoteOnLabel: true,
        dispenseItems: [
          {
            drugName: 'Sample Drug',
            doseUnit: '100',
            doseUnitOfMeasure: 'mg',
            volumeUnit: '',
            volumeUnitOfMeasure: '',
            notes: ['Test Note 1', 'Test Note 2'],
            infusionNotes: ['Infusion Note 1', 'Infusion Note 2'],
            isToxic: true,
            isMultiLot: true,
            route: 'INTRA-LESION',
            instructions: [this.adminNotes],
            ndcLotList: [
              { ndc: '12345-1234-01', lotDetails: [{ lotNumber: 'Lot100', expirationDate: new Date(Date.now()) }, { lotNumber: 'Lot101', expirationDate: new Date(Date.now()) }] },
              { ndc: '12345-1234-11', lotDetails: [{ lotNumber: 'Lot200', expirationDate: new Date(Date.now()) }, { lotNumber: 'Lot201', expirationDate: new Date(Date.now()) }] },
            ],
          } as PrintingLabelDispenseItem,
        ],
      } as PrintingLabel;

      this.stationPrintingService.printSingleDispenseItemLabels(printingLabel);
      this.onClose.emit();
    }
  }

  onCancelClick(): void {
    this.onClose.emit();
  }
}
